import { render, staticRenderFns } from "./plus-btn.vue?vue&type=template&id=704e467e&scoped=true&"
import script from "./plus-btn.vue?vue&type=script&lang=ts&"
export * from "./plus-btn.vue?vue&type=script&lang=ts&"
import style0 from "./plus-btn.vue?vue&type=style&index=0&id=704e467e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e467e",
  null
  
)

export default component.exports